const constants = {
  header_height: 40,
  header_margin: 104,
};

export default { constants };
